var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApplication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 0.75H3.25C1.875 0.75 0.75 1.875 0.75 3.25V20.75C0.75 22.125 1.875 23.25 3.25 23.25H20.75C22.125 23.25 23.25 22.125 23.25 20.75V7L17 0.75ZM7 5.75H10.75C11.4375 5.75 12 6.3125 12 7C12 7.6875 11.4375 8.25 10.75 8.25H7C6.3125 8.25 5.75 7.6875 5.75 7C5.75 6.3125 6.3125 5.75 7 5.75ZM17 18.25H7C6.3125 18.25 5.75 17.6875 5.75 17C5.75 16.3125 6.3125 15.75 7 15.75H17C17.6875 15.75 18.25 16.3125 18.25 17C18.25 17.6875 17.6875 18.25 17 18.25ZM17 13.25H7C6.3125 13.25 5.75 12.6875 5.75 12C5.75 11.3125 6.3125 10.75 7 10.75H17C17.6875 10.75 18.25 11.3125 18.25 12C18.25 12.6875 17.6875 13.25 17 13.25ZM15.75 7V3.25L20.75 8.25H17C16.3125 8.25 15.75 7.6875 15.75 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplication);
export default __webpack_public_path__ + "static/media/application.d012cb9b48277659e73d284e6571fbf9.svg";
export { ForwardRef as ReactComponent };